document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector(".job-offer-section__grid");
  const btn = document.querySelector(".job-offer-section__load-more");

  if (!grid || !btn) return;

  const ajaxUrl = btn.dataset.url;
  const nonce = btn.dataset.nonce;

  let offset = parseInt(btn.dataset.offset, 10) || 3;
  const ppp = parseInt(btn.dataset.ppp, 10) || 3;

  let loading = false;

  btn.addEventListener("click", async () => {
    if (loading) return;

    loading = true;

    btn.classList.add("is-loading");
    btn.disabled = true;

    const formData = new FormData();
    formData.append("action", "job_offer_load_more");
    formData.append("nonce", nonce);
    formData.append("offset", offset);
    formData.append("ppp", ppp);

    try {
      const res = await fetch(ajaxUrl, {
        method: "POST",
        body: formData,
      });

      const json = await res.json();

      if (!json || !json.success) {
        console.error("Failed to load data");
        btn.disabled = false;
        return;
      }

      if (json.data?.html) {
        grid.insertAdjacentHTML("beforeend", json.data.html);
        offset += ppp;
        btn.dataset.offset = offset;
      }

      if (!json.data?.has_more) {
        btn.remove();
      } else {
        btn.disabled = false;
      }
    } catch (e) {
      btn.disabled = false;
      console.error("Load more error:", e);
    } finally {
      loading = false;
      btn.classList.remove("is-loading");
    }
  });
});
